import { FruHttpService } from '../../../services/fru-http.service';
import { AdvertisedRateBucket } from '../../../shared/rate.model';

// FRU-23774: Hope's calculators price the payment on their own reviewed pairs, which they used to ask for only when they rendered,
// so on a slow phone the payment filled in 1.5 to 3.5 s after the calculator. The startup warm-up (app.module.ts) asks for them
// first; peekRateFinderRates shares the request with the calculator. Kept out of app.module so a test can load it alone.

/** The reviewed pairs a calculator landing prices its payment on: the mortgage calculator, purchase and refinance 30-year fixed;
 *  the home equity calculator, cash out 10-year fixed. */
export function calculatorRateBuckets(qp: URLSearchParams): AdvertisedRateBucket[] {
  const type = (qp.get('type') || '').toLowerCase();
  // The home equity signal wins, as it does in the chat: calc=homeequity seeds the home equity path and skips the loan type
  // step, so on type=calculator&calc=homeequity the home equity calculator is the one that renders.
  if (type === 'equity-calculator' || (qp.get('calc') || '').toLowerCase() === 'homeequity') {
    return [{ purpose: 'cash_out', product: '10yr_fixed' }] as AdvertisedRateBucket[];
  }
  if (type === 'calculator' || type === 'mortgage-calculator') {
    return [{ purpose: 'purchase', product: '30yr_fixed' }, { purpose: 'refinance', product: '30yr_fixed' }] as AdvertisedRateBucket[];
  }
  return [];
}

/** Hope entries only (startAssistant=1): the original form never asks for these. */
export function warmCalculatorRates(fruHttp: Pick<FruHttpService, 'peekRateFinderRates'>, search: string): void {
  try {
    if (!/[?&]startAssistant=1(?:&|$)/i.test(search || '')) { return; }
    calculatorRateBuckets(new URLSearchParams(search)).forEach((bucket) => {
      fruHttp.peekRateFinderRates(bucket).subscribe({ error: () => { /* the calculator owns its own fallback */ } });
    });
  } catch (e) { /* a warm-up must never break bootstrap */ }
}
